import '@ssml-editor/core';
import { wrapper, mark, EditorUtils, text } from '@ssml-editor/vue';
import '../phoneme/alphabet.enum.js';
import './say-as-interpretation.enum.js';
import '@ssml-editor/modules';
import '../speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                                      */
import 'cmu-pronouncing-dictionary';
/* empty css                                          */
import { markClickHandler } from '../../toolbar-menu/menu.method.js';
/* empty css                                        */
import '../../toolbar-menu/say-as/constant.js';
/* empty css                                        */
import '@element-plus/icons-vue';
/* empty css                                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                                       */
/* empty css                                         */
/* empty css                                     */
/* empty css                                                  */
/* empty css                                             */
/* empty css                                         */
import '../../toolbar-menu/voice/voice-menu.vue.js';

const sayAsRenderElement = ({
  element,
  children,
  attributes,
  editor
}) => {
  const node = element;
  return wrapper(
    attributes,
    mark(
      node.mark,
      void 0,
      { "background-color": "var(--cosy-voice-say-as)" },
      {
        onClick: (event) => {
          event.stopPropagation();
          markClickHandler(editor, node);
        }
      },
      ["iconfont-ssml-editor", "icon-ssml-editor-close-fill"],
      {
        onClick: (event) => {
          event.stopPropagation();
          EditorUtils.removeSpace(editor, node);
          EditorUtils.unwrapAllByNode(editor, node);
        }
      }
    ),
    text(children, void 0, void 0, void 0, {
      color: "var(--cosy-voice-say-as)"
    })
  );
};

export { sayAsRenderElement };
//# sourceMappingURL=render-element.js.map
